import { useState } from "react"
import slidersign from "./slidersign.png"
import selecticon from "./selecticon.png"
import { Box } from "theme-ui"
import { MyTableComponent, SignalGroups } from "components"
import { useTranslation } from "react-i18next"
import { useFetchDeviceMessagesQuery } from "../../store/Features/devices/deviceMessages-api-slice"

import { motion, AnimatePresence } from "framer-motion"

export const MessagesTable = () => {
 const { t } = useTranslation("translation")
 const { data, isLoading } = useFetchDeviceMessagesQuery()

 const columns = [
  { Header: t("Device"), accessor: "common_information.device_name" },
  { Header: t("message"), accessor: "message" },
  { Header: t("Time"), accessor: "timestamp" },
  { Header: t("degree"), accessor: "degree" },
  { Header: t("Receipt"), accessor: "receipt" },
  {
   Header: t("comments"),
   accessor: "comments",
   Cell: (item: any) => {
    return (
     item?.row?.original?.comments?.length > 0 &&
     item?.row?.original?.comments?.map((comment: string, index: number) => (
      <h1 key={index}>{comment}</h1>
     ))
    )
   },
  },

  {
   Header: t("redirects"),
   accessor: "redirects.",
  },
 ]

 const [toggle, setToggle] = useState<boolean>(false)

 return (
  <div
   className={`w-[96%] mx-auto relative min-h-[1300px] lg:min-h-full  ${toggle ? "mb-36" : ""}`}
  >
   <div className="flex justify-between mx-2 py-4 ">
    <h1 className="font-semibold text-2xl Jakarta-font">{t("messages")}</h1>
    <div
     onClick={() => {
      setToggle(!toggle)
     }}
     className="bg-white h-10 w-10 rounded flex justify-center items-center cursor-pointer"
    >
     <img src={slidersign} alt="slidersignimg" />
    </div>
   </div>
   <AnimatePresence>
    {toggle && (
     <motion.div
      initial={{ opacity: 0, height: 0 }}
      animate={{ opacity: 1, height: "auto" }}
      exit={{ opacity: 0, height: 0 }}
      transition={{ duration: 0.9, ease: "easeInOut" }}
     >
      <SignalGroups />
     </motion.div>
    )}
   </AnimatePresence>

   <Box bg="highlight" className="py-2 px-2">
    <Box bg="light_gray" className="flex justify-between py-4 rounded mx-2 px-3">
     <div className="flex items-center">
      <div>
       <img className="rotate-[90deg]" src={selecticon} alt="selecticon" />
      </div>
      <h1 className="font-semibold font-sm Jakarta-font">1000 {t("reports")}</h1>
     </div>

     <div className="custom-checkbox">
      <input type="checkbox" id="cx" />
      <label className="font-semibold font-sm Jakarta-font" htmlFor="cx">
       {t("updateAutomatically")}
      </label>
     </div>
    </Box>
   </Box>

   {/* ====== TableComponent ====== */}
   <MyTableComponent
    fullHeight={false}
    columns={columns}
    data={data ? data : []}
    paginate={true}
    isLoading={isLoading}
   />
  </div>
 )
}
